import React, { useEffect, useState } from "react";
import bannerimage from "../Assets/images/background/main_bg.svg";
import "./MainBanner.scss";
import Button from "./Buttons/Button";
import Renderer from "./Renderer";
import { getSubcategoryWiseContent } from "../services/getSubcategoryWiseContent";
import certificate1 from "../Assets/images/New/certificate1.png";
import certificate2 from "../Assets/images/New/certificate2.png";
import certificate3 from "../Assets/images/New/certificate3.png";
import certificate4 from "../Assets/images/New/certificate4.png";

const MainBanner = ({
  id = "",
  setIsModelOpen = () => {},
  btnDisabled = false,
  isHome = false,
  isService = true,
  btnText = "Get Help",
  setTypeData = () => {},
}) => {
  const [pageData, setPageData] = useState([]);
  const fetchData = async () => {
    await getSubcategoryWiseContent(id)
      .then((data) => {
        setPageData(data);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    fetchData();
  }, [id]);
  return (
    <>
      <div
        className="banner-main-wrapper"
        style={{ backgroundImage: `url(${bannerimage})` }}
      >
        <div className="banner-content">
          <div className="banner-content-title-wrapper">
            <div className="title">
              <Renderer content={pageData?.bannerData?.title} />
            </div>
          </div>
          <div
            className="banner-content-subtitle"
            style={{ marginBottom: !isService ? "20px" : "" }}
          >
            <span>
              <Renderer content={pageData?.bannerData?.description} />
            </span>
          </div>
          {isService && (
            <div className="banner-content-available-text">
              <span>Available 24x7</span>
            </div>
          )}

          {!btnDisabled && (
            <div className="banner-btn-wrapper">
              {isHome ? (
                <div className="d-flex flex-column flex-md-row gap-3 justify-content-center mt-2 mb-2">
                  <Button
                    varient="primary"
                    text="Homework Help"
                    className="w-100"
                    onClick={() => {
                      setTypeData({
                        serviceType: "HomeworkHelp",
                        type: "mcqHelp",
                        totalSteps: 1,
                      });
                      setIsModelOpen(true);
                    }}
                  />

                  <Button
                    varient="primary"
                    text="Assignment Help"
                    className="w-100"
                    onClick={() => {
                      setTypeData({
                        serviceType: "AssignmentHelp",
                        type: "assignmentHelp",
                        totalSteps: 1,
                      });
                      setIsModelOpen(true);
                    }}
                  />

                  <Button
                    varient="primary"
                    text="Live Session Help"
                    className="w-100"
                    onClick={() => {
                      setTypeData({
                        serviceType: "LiveSessionHelp",
                        type: "livesessionHelp",
                        totalSteps: 3,
                      });
                      setIsModelOpen(true);
                    }}
                  />
                </div>
              ) : (
                <Button
                  varient="primary"
                  text={btnText}
                  onClick={() => setIsModelOpen(true)}
                />
              )}
            </div>
          )}

          <div className="container pt-4 mt-4">
            <div className="row justify-content-center">
              <div className="col-3 col-md-3 mb-3">
                <img
                  className="img-fluid-home"
                  src={certificate1}
                  alt="Certificate 1"
                />
              </div>
              <div className="col-3 col-md-3 mb-3">
                <img
                  className="img-fluid-home"
                  src={certificate2}
                  alt="Certificate 2"
                />
              </div>
              <div className="col-3 col-md-3 mb-3">
                <img
                  className="img-fluid-home"
                  src={certificate3}
                  alt="Certificate 3"
                />
              </div>
              <div className="col-3 col-md-3 mb-3">
                <img
                  className="img-fluid-home"
                  src={certificate4}
                  alt="Certificate 4"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainBanner;
